import { useTravellerType } from './useTravellerType';
import { useSubscription } from '../context/SubscriptionContext';
import { isAgentPlan } from '../lib/subscriptions';

// Gamification (daily check-in, streaks, badges, XP, ranks, leaderboard,
// weekly featured spot) is reserved for individual Enthusiasts. Casuals opt
// out of gamification at onboarding, and Agents (B2B) buy curated content
// with money instead of earning credits in-app.
export function useGamification() {
  const { isCasual } = useTravellerType();
  const { subscription } = useSubscription();
  const isAgent = isAgentPlan(subscription.planSlug);
  return {
    enabled: !isCasual && !isAgent,
    isCasual,
    isAgent,
  };
}
